"use client";

import type { ReactNode } from "react";
import { forwardRef, memo } from "react";

import { cn } from "@acme/ui";
import { TabsTrigger } from "@acme/ui/tabs";

interface CurvedTabProps {
  value: string;
  children: ReactNode;
  className?: string;
}

export const CurvedTab = memo(
  forwardRef<HTMLDivElement, CurvedTabProps>(function CurvedTab(
    { value, children, className },
    ref,
  ) {
    return (
      <TabsTrigger
        value={value}
        className={cn(
          "group p-0 select-none data-[state=active]:z-20 data-[state=active]:bg-inherit! data-[state=active]:shadow-none!",
          className,
        )}
        asChild
      >
        <div className="relative z-1 h-8" ref={ref}>
          <div className="pointer-events-none absolute top-px bottom-0 left-0 w-full opacity-0 transition-opacity duration-200 group-hover:opacity-50 group-data-[state=active]:opacity-100">
            <svg
              className="h-full w-full"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
            >
              <svg width="52%" height="100%">
                <use
                  xlinkHref="#tab-geometry-left"
                  width={190}
                  height={32}
                  className="fill-muted"
                />
              </svg>
              <g transform="scale(-1, 1)">
                <svg width="52%" height="100%" x="-100%" y={0}>
                  <use
                    xlinkHref="#tab-geometry-right"
                    width={190}
                    height={32}
                    className="fill-muted"
                  />
                </svg>
              </g>
            </svg>
          </div>
          <div className="relative flex max-w-[250px] items-center overflow-hidden rounded-t-lg pr-3 pl-4">
            {children}
          </div>
        </div>
      </TabsTrigger>
    );
  }),
);
